import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {map} from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { CommissionPromoterAdditional } from 'src/oldApp/model/commission-promoter-additional';

@Injectable({
  providedIn: 'root'
})
export class CommissionPromoterAdditionalService {

  private url:string;

  constructor(private http:HttpClient) {
    this.url=environment.services_url;
  }


  getActive=()=> {
    return this.http.get(`${this.url}/CommissionPromoterAdditional/getActive`)
      .pipe(
        map((resp:any)=> resp)
      );
  }

  getCommissions=()=> {
    return this.http.get(`${this.url}/CommissionPromoterAdditional/getCommissions`)
      .pipe(
        map((resp:any)=> resp)
      );
  }

  getBusinessLines=()=> {
    return this.http.get(`${this.url}/CommissionPromoterAdditional/getBusinessLines`)
      .pipe(
        map((resp:any)=> resp)
      );
  }

  getOwnerTypes=()=> {
    return this.http.get(`${this.url}/CommissionPromoterAdditional/getOwnerTypes`)
      .pipe(
        map((resp:any)=> resp)
      );
  }

  getProductsByBusinessLine=(listIds:number[])=> {
    return this.http.post(`${this.url}/CommissionPromoterAdditional/getProductsByBusinessLine`, listIds)
      .pipe(
        map((resp:any)=> resp)
      );
  }

  getAfiliatesByProduct=(listIds:number[])=> {
    return this.http.post(`${this.url}/CommissionPromoterAdditional/getAfiliatesByProduct`, listIds)
      .pipe(
        map((resp:any)=> resp)
      );
  }

  getPaymentTermsByAfiliate=(listIds:number[])=> {
    return this.http.post(`${this.url}/CommissionPromoterAdditional/getTermsByAfiliate`, listIds)
      .pipe(
        map((resp:any)=> resp)
      );
  }

  getAllPaginated=(request:any)=> {
    return this.http.post(`${this.url}/CommissionPromoterAdditional/getAllPaginated`, request)
      .pipe(
        map((resp:any)=> resp)
      );
  }

  delete=(model:CommissionPromoterAdditional)=> {
    return this.http.post(`${this.url}/CommissionPromoterAdditional/delete`, model)
      .pipe(
        map((resp:any)=> resp)
      );
  }

  toggleActive=(active:number)=> {
    return this.http.get(`${this.url}/CommissionPromoterAdditional/toggleActive/${active}`)
      .pipe(
        map((resp:any)=> resp)
      );
  }

  saveUpdate=(model:CommissionPromoterAdditional)=> {
    return this.http.post(`${this.url}/CommissionPromoterAdditional/saveUpdate`, model)
      .pipe(
        map((resp:any)=> resp)
      );
  }

  saveUpdateNew=(model:any)=> {
    return this.http.post(`${this.url}/CommissionPromoterAdditional/saveUpdateNew`, model)
      .pipe(
        map((resp:any)=> resp)
      );
  }

  download=(request:any)=> {
    return this.http.post(`${this.url}/CommissionPromoterAdditional/download`, request)
      .pipe(
        map((resp:any)=> resp)
      );
  }

}
